import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';

import { FillStudentComponent } from './fill-student/fill-student.component';
import { FramerRequestComponent } from './framer-request/framer-request.component';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MessageService } from 'primeng/api';
import { DividerModule } from 'primeng/divider';
import { CheckboxModule } from 'primeng/checkbox';
import { EditorModule } from 'primeng/editor';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ToastModule } from 'primeng/toast';

import { AccepteOffreConditionComponent } from './accepte-offre-condition/accepte-offre-condition.component';

@NgModule({
  declarations: [
    FillStudentComponent,
    FramerRequestComponent,
    AccepteOffreConditionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    DropdownModule,
    CalendarModule,
    DividerModule,
    CheckboxModule,
    EditorModule,
    TableModule,
    TooltipModule,
    RadioButtonModule,
    ProgressSpinnerModule,
    MessagesModule,
    OverlayPanelModule,
    ToastModule
  ],
  providers: [MessageService]
})
export class ToBackModule { }
